module.exports = __webpack_public_path__ + "static/media/1.781e6076.jpeg";